import React from 'react'

type Props = { children: React.ReactNode; resetKey?: string }
type State = { failed: boolean }

/** Shows a reload prompt instead of a white screen when a lazy route chunk cannot be loaded. */
class ChunkErrorBoundary extends React.Component<Props, State> {
  state: State = { failed: false }

  static getDerivedStateFromError(): State {
    return { failed: true }
  }

  componentDidUpdate(prevProps: Props) {
    if (this.state.failed && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ failed: false })
    }
  }

  componentDidCatch(error: Error) {
    console.error('Route failed to load:', error)
  }

  render() {
    if (!this.state.failed) return this.props.children
    return (
      <div role='alert' style={{ padding: '64px 16px', textAlign: 'center' }}>
        <p>Something went wrong while loading this page. Please reload and try again.</p>
        <button type='button' onClick={() => window.location.reload()}>
          Reload
        </button>
      </div>
    )
  }
}

export { ChunkErrorBoundary }
